import ICasRenderCellProps from './ICasRenderCellProps';

export default function getCasTableCellValue({ row, column }: ICasRenderCellProps) {
  return column.field ? row?.[column.field] : null;
}
